const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));
export const DEFAULT_RATIO = 1.5;
export function cardGeometry(ratio, width) {
  const r = ratio || DEFAULT_RATIO;
  const portrait = r < 0.95;
  return { portrait, side: portrait && width >= 480, aspect: portrait ? clamp(r, 0.66, 1) : clamp(r, 1.3, 2) };
}
